<template>
    <div class="main-container">
        <nav class="row mb-3">
            <div class="col"
                 v-for="(filter, index) in LevelFilters"
                 @click="toggleFilter(index)"

            >
                <div class="btn btn-sm"
                     v-bind:class="[filter.button, filter.active ? 'active' : '']"
                >
                    <div class="d-flex  align-items-center ">
                        <span>{{index}}</span>
                        <!--<span v-if="!unknown_totals" v-bind:class="filter.text">-->
                        <!--{{filter.total}}-->
                        <!--</span>-->
                        <span v-if="!unknown_totals">({{filter.total}})</span>
                    </div>
                </div>
            </div>
        </nav>
        <!--date and selection filter stuff?-->
        <div class="row mb-3">
            <!--Filters-->
            <section class="col-12 col-md-6">
                <div class="card">
                    <div class="card-body mt-3">
                        <form class="">
                            <div class="d-block d-md-flex justify-content-md-between align-items-center">
                                <div class="md-form mb-0">
                                    <i class="fa prefix fa-calendar"></i>
                                    <input id="filter_date" class="form-control" type="date" v-model="start_date">
                                    <label for="filter_date" class="active">From</label>
                                </div>
                                <div class="md-form mb-0">
                                    <input id="page_length" class="form-control" type="number" v-model="page_length">
                                    <label for="page_length"># results</label>
                                </div>
                            </div>
                            <div class="d-block d-md-flex justify-content-md-between align-items-center">
                                <div class="form-check pl-0">
                                    <input id="client_connection" class="form-check-input" type="checkbox"
                                           v-on:click="resetTotals()" v-model="uses_client">
                                    <label for="client_connection" class="form-check-label">Use client's
                                        connection</label>
                                </div>

                                <div v-bind:class="loading ? 'disabled' : ''"
                                     v-on:click="newSearch()"
                                     class="btn btn-primary">
                                    <i class="material-icons">search</i>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </section>
            <!--Results summary-->
            <div class="col-12 col-md-6">
                <div class="card ">
                    <div class="card-body ">
                        <h4 class="h4-responsive" v-if="last_search.uses_client">Results - Client connection</h4>
                        <h4 class="h4-responsive" v-else>Results</h4>
                        <div class="py-2 ">Levels: {{last_search.filter_levels}}</div>
                        <div class="py-2 d-flex justify-content-between align-items-center ">
                            <div class="d-inline-block">
                                <span class="bold mr-3">Date:</span>
                                <span>
                                {{formatDate(last_search.start_date)}}
                            </span>
                            </div>
                            <div class="d-inline-block">
                                <span class="bold mr-3">Total:</span>
                                <span>
                                {{total}}
                            </span>
                            </div>
                        </div>
                        <div class="py-2 d-flex justify-content-between align-items-center ">
                            <div class="d-inline-block">
                                <span class="bold mr-3">Pages:</span>
                                <span>
                                {{last_search.page_length}}
                            </span>
                            </div>
                            <div class="d-inline-block">
                                <span class="bold mr-3">Current:</span>
                                <span>
                                {{last_search.page}}
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--table results-->
        <!--v-if="loading"-->
        <div v-if="loading" class="text-center">
            <div class="loader fs2"><span>{</span><span>}</span></div>
        </div>
        <transition name="fade">
            <div v-if="!loading && Logs.length > 0">
                <template data-element-description="log records" v-for="log in Logs">
                    <div class="card mb-2">
                        <div class="card-body mb-3 pb-1">
                            <div class="">
                                <div v-on:click="loadSingle(log.id)"
                                     class="mx-0 mt-0 cursor-pointer btn d-flex justify-content-between align-items-center "
                                     :class="[
                                        {
                                            'active':(loaded_log.loaded) && (Logs.length > 0 && Logs.length < total) && (loaded_log.data.log.id == log.id)

                                        },
                                        LevelFilters[log.level].background
                                     ]"
                                >
                                    <!--id-->
                                    <span class="pr-3">{{log.id}}</span>
                                    <!--date-->
                                    <span class="px-3 d-block d-md-none">
                                            {{formatDate(log.created_at,'short')}}
                                        </span>
                                    <span class="px-3 d-none d-md-block">
                                            {{formatDate(log.created_at,'long')}}
                                        </span>
                                    <div
                                            :class="[
                                            {
                                                disabled:loading
                                            },
                                            LevelFilters[log.level].text
                                        ]"

                                    >
                                        {{log.level}}
                                    </div>
                                </div>
                            </div>
                            <!--line break-->
                            <!--message-->
                            <!--<div v-if="(loaded_log.loaded) && (Logs.length > 0 && Logs.length < total) && (loaded_log.data.log.id == log.id)">-->
                                <!---->
                            <!--</div>-->
                            <div class="text-truncate"
                                 :title="log.message"
                                 v-if="!((loaded_log.loaded) && (Logs.length > 0 && Logs.length < total) && (loaded_log.data.log.id == log.id))">
                                <code>{{log.message}}</code>
                            </div>
                        </div>
                        <div class="card-body mt-0 pt-1"
                             v-if="(loaded_log.loaded) && (Logs.length > 0 && Logs.length < total) && (loaded_log.data.log.id == log.id)">

                            <!--{{debug(loaded_log.data)}}-->
                            <div>
                                <div class="p-2 mb-2 color-block elegant-color">
                                    <code class="">&lt;{{loaded_log.data.log.message}}&gt;</code>
                                </div>
                                <div class="list-group ">
                                    <!--route-->
                                    <div class="list-group-item">
                                        <div class="small font-weight-light">Route:</div>
                                        <div class="">{{loaded_log.data.log.route}}</div>
                                    </div>
                                    <!--action-->
                                    <div class="list-group-item">
                                        <div class="small font-weight-light">Controller - Action:</div>
                                        <div class="">{{loaded_log.data.log.controller}} @
                                            {{loaded_log.data.log.action}}
                                        </div>
                                    </div>
                                    <!--file-->
                                    <div class="list-group-item">
                                        <div class="small font-weight-light">File - Line:</div>
                                        <div class="">{{loaded_log.data.log.file}} - {{loaded_log.data.log.line}}
                                        </div>
                                    </div>
                                    <!--user-->
                                    <details class="list-group-item">
                                        <summary>User</summary>
                                        <div v-if="loaded_log.data.user == null">null</div>
                                        <div v-else>
                                            <table class="table table-sm table-responsive">
                                                <thead>
                                                <tr>
                                                    <th>Property</th>
                                                    <th>Value</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(value, key) in loaded_log.data.user">
                                                    <td>{{key}}</td>
                                                    <td v-if="key === 'roles'">

                                                            <span class="badge badge-sm badge-info"
                                                                  v-for="role in value">{{role.slug}}</span>

                                                    </td>
                                                    <td v-else>{{value}}</td>
                                                </tr>
                                                </tbody>
                                            </table>

                                        </div>
                                    </details>
                                    <!--trace-->
                                    <details class="list-group-item">
                                        <summary>
                                            Trace
                                        </summary>
                                        <div v-if="loaded_log.data.log.trace == null">null</div>
                                        <div v-else>
                                            <table class="table table-sm table-responsive">
                                                <thead>
                                                <tr>
                                                    <th>File</th>
                                                    <th>Line</th>
                                                    <th>Class</th>
                                                    <th>Function</th>
                                                    <th>Args</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(_trace, index) in loaded_log.data.log.trace">
                                                    <td>{{_trace.file}}</td>
                                                    <td>{{_trace.line}}</td>
                                                    <td>{{_trace.class}}</td>
                                                    <td>{{_trace.function}}</td>
                                                    <td>
                                                        <button
                                                                class="btn btn-sm btn-info"
                                                                data-toggle="collapse"
                                                                :data-target="'#args_' + index"
                                                                aria-expanded="false"
                                                                :aria-controls="'args_' + index"
                                                        ><i class="fa fa-eye"></i></button>
                                                        <div :id="'args_' + index" class="collapse">
                                                            {{_trace.args}}
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </details>
                                    <!--context-->
                                    <div class="list-group-item" v-if="loaded_log.data.log.context == null">
                                        No context
                                    </div>
                                    <details class="list-group-item">
                                        <summary>Context</summary>
                                        <div id="context_info" class="collapse">

                                            <div class="table table-sm table-responsive">
                                                <div>
                                                    <div>
                                                        <div>Property</div>
                                                        <div>Value</div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div v-for="(value, key) in loaded_log.data.log.context">
                                                        <div>{{key}}</div>
                                                        <div>{{value}}</div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </details>
                                    <!--extra-->
                                    <details class="list-group-item">
                                        <summary>Extra</summary>
                                        <div v-if="loaded_log.data.log.extra == null">null</div>
                                        <div v-else>
                                            <table class="table table-sm table-responsive">
                                                <thead>
                                                <tr>
                                                    <th>Property</th>
                                                    <th>Value</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(value, key) in loaded_log.data.log.extra">
                                                    <td>{{key}}</td>
                                                    <td>{{value}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </details>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </transition>
        <transition name="fade">
            <div v-if="!loading" class="text-center">

                <a v-if="Logs.length > 0 && Logs.length < total" v-on:click="page ++; searchLogs();"
                   class="btn btn-sm btn-info">MORE</a>
                <span v-else-if="Logs.length > 0">No more results</span>
                <span v-else>No results found</span>
            </div>
        </transition>

    </div>
</template>

<style>
    .loader {
        color: #3498db;
        font-family: Consolas, Menlo, Monaco, monospace;
        font-weight: bold;
        font-size: 3rem;
        opacity: 0.8;
    }

    .loader span {
        display: inline-block;
        -webkit-animation: pulse 0.4s alternate infinite ease-in-out;
        animation: pulse 0.4s alternate infinite ease-in-out;
    }

    .loader span:nth-child(odd) {
        -webkit-animation-delay: 0.4s;
        animation-delay: 0.4s;
    }

    @-webkit-keyframes pulse {
        to {
            -webkit-transform: scale(0.8);
            transform: scale(0.8);
            opacity: 0.5;
        }
    }

    @keyframes pulse {
        to {
            -webkit-transform: scale(0.8);
            transform: scale(0.8);
            opacity: 0.5;
        }
    }

</style>

<script>
    // add imports here
    import {_} from 'underscore';
    // import {getDate, DATE_FORMAT} from "../../../../../app/Shared/Resources/Assets/js/helpers/format.date";
    import {getDate, DATE_FORMAT} from '../../../../../../app/Shared/Resources/Assets/js/helpers/format.date'
    //ADD JSDOC HERE!!!!!
    export default {
        props: ['content'],
        mounted() {
            this.url = this.content.url;
            this.searchLogs();
        },
        data() {
            return {
                url: '',

                start_date: new Date().toJSON().slice(0, 10),
                page: 1,
                page_length: 15,
                uses_client: false,
                loading: false,
                total: 0,
                unknown_totals: true,

                loaded_log: {
                    loaded: false,
                    data: {
                        user: null,
                        log: null
                    }
                },

                last_search: {
                    start_date: new Date().toJSON().slice(0, 10),
                    filter_levels: ['ERROR', 'CRITICAL', 'ALERT', 'EMERGENCY'],
                    page_length: 5,
                    uses_client: false,
                    page: 1
                },

                LevelFilters: {
                    INFO: {
                        button: 'btn btn-outline-info',
                        text: 'badge badge-info',
                        background:'btn-outline-info',
                        total: 0,
                        active: false
                    },
                    DEBUG: {
                        button: 'btn btn-outline-info-dark',
                        text: 'badge badge-info',
                        background:'btn-outline-info',
                        total: 0,
                        active: false
                    },
                    NOTICE: {
                        button: 'btn btn-outline-secondary',
                        text: 'badge badge-secondary',
                        background:'btn-outline-primary',
                        total: 0,
                        active: false
                    },
                    WARNING: {
                        button: 'btn btn-outline-warning',
                        text: 'badge badge-warning',
                        background:'btn-outline-warning',
                        total: 0,
                        active: false
                    },
                    ERROR: {
                        button: 'btn btn-outline-danger',
                        text: 'badge badge-danger-dark',
                        background:'btn-outline-danger',
                        total: 0,
                        active: false
                    },
                    CRITICAL: {
                        button: 'btn btn-outline-danger-dark',
                        text: 'badge badge-danger',
                        background:'btn-outline-danger-dark',
                        total: 0,
                        active: false
                    },
                    ALERT: {
                        button: 'btn  btn-outline-accent-dark',
                        text: 'badge deep-orange',
                        background:'btn-outline-danger-dark',
                        total: 0,
                        active: false
                    },
                    EMERGENCY: {
                        button: 'btn  btn-outline-danger-dark',
                        text: 'badge deep-orange',
                        background:'btn-outline-danger-dark',
                        total: 0,
                        active: false
                    }
                },
                Logs: [] //This will have all the logs
            }
        },
        methods: {
            formatDate(date, format) {
                return getDate(date, DATE_FORMAT.date_time[format]);
            },
            debug() {
                let args = Array.prototype.slice.call(arguments);

                // 2. Prepend log prefix log string
                // args.unshift(LOG_PREFIX + " ");

                // 3. Pass along arguments to console.log
                console.log.apply(console, args);
            },
            searchLogs(newSearch = false) {
                let _this = this;

                if (newSearch) {
                    _this.last_search = {
                        start_date: _this.start_date,
                        filter_levels: _this.activeLevels(),
                        page_length: _this.page_length,
                        uses_client: _this.uses_client,
                        page: _this.page
                    }
                }
                else {
                    //If not a new search, only obays to the page
                    _this.last_search.page = _this.page;
                }

                _this.loading = true;

                axios.get(_this.url + '/search', {
                    params: _this.last_search
                })
                    .then(function (response) {
                        _this.loading = false;
                        _this.Logs.push.apply(_this.Logs, response.data.logs);
                        _this.total = response.data.total;

                        _this.resetTotals();

                        for (let total in response.data.total_levels) {
                            // skip loop if the property is from prototype
                            if (!response.data.total_levels.hasOwnProperty(total)) {
                                continue;
                            }

                            _this.LevelFilters[response.data.total_levels[total].level].total = response.data.total_levels[total].total;
                        }
                        _this.unknown_totals = false;
                    })
                    .catch(function (e) {
                        _this.loading = false;
                        _this.Logs = [];
                        _this.total = 0;

                        if (e.response.status === 400) {
                            toastr.error('Please select a client');
                        }
                        else {
                            toastr.error('Failed to search for logs!');
                        }
                    })
            },

            resetTotals() {
                this.unknown_totals = true;
                for (let key in this.LevelFilters) {
                    // skip loop if the property is from prototype
                    if (!this.LevelFilters.hasOwnProperty(key)) {
                        continue;
                    }

                    this.LevelFilters[key].total = 0;
                }
            },

            newSearch() {
                if (this.loading) {
                    return;
                }

                this.loaded_log.loaded = false;
                this.page = 1;
                this.total = 0;
                this.Logs = [];
                this.searchLogs(true);
            },

            activeLevels() {
                let levels = [];

                for (let key in this.LevelFilters) {
                    // skip loop if the property is from prototype
                    if (!this.LevelFilters.hasOwnProperty(key)) {
                        continue;
                    }

                    if (this.LevelFilters[key].active) {
                        levels.push(key);
                    }
                }

                return levels;
            },

            toggleFilter(filter_index) {
                this.LevelFilters[filter_index].active = !this.LevelFilters[filter_index].active;
            },

            loadSingle(log_id) {
                let _this = this;
                if (_this.loaded_log.loaded) {
                    // already loaded so toggle it
                    _this.loaded_log.loaded = false;
                    return;
                }

                _this.loading = true;

                axios.get(_this.url + '/' + log_id + '?uses_client=' + _this.last_search.uses_client)
                    .then(function (response) {
                        _this.loading = false;
                        _this.loaded_log.loaded = true;
                        _this.loaded_log.data.user = response.data.user;
                        _this.loaded_log.data.log = response.data.log;
                    })
                    .catch(function (e) {
                        _this.loading = false;
                        _this.loaded_log.loaded = false;
                        _this.loaded_log.data.user = null;
                        _this.loaded_log.data.log = null;

                        if (e.response.status === 400) {
                            toastr.error('Please select a client');
                        }
                        else {
                            toastr.error('Failed to load the log ' + log_id + '!');
                        }
                    })
            }
        }
    }
</script>


<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/logs/LogSystemDisplay.vue?78e17992